function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "68",
  height: "68",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 0a2 2 0 00-2 2v28a2 2 0 002 2h8v2a7 7 0 01-7 7H12a3 3 0 00-3 3v4H2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V50a2 2 0 00-2-2h-7v-4a1 1 0 011-1h14a8.983 8.983 0 007-3.343V48h-7a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V50a2 2 0 00-2-2h-7v-8.343A8.983 8.983 0 0042 43h14a1 1 0 011 1v4h-7a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V50a2 2 0 00-2-2h-7v-4a3 3 0 00-3-3H42a7 7 0 01-7-7v-2h8a2 2 0 002-2V2a2 2 0 00-2-2H25zm18 2H25v28h18V2zM18 50H2v16h16V50zm48 0H50v16h16V50zm-40 0v16h16V50H26z",
  fill: "url(#svg2514708248__paint0_linear)"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg2514708248__paint0_linear",
  x1: "34",
  x2: "34",
  y2: "68",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#A0F"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#00A3D7"
})))));